import React from 'react';
import get from 'lodash/get';
import ImageMapBanner from 'yoda-core-components/lib/components/ImagemapBannerResponsive/ImagemapBannerResponsive';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import isEmpty from 'lodash/isEmpty';
import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
import { useSelector } from 'react-redux';
import { useWindowSize, deviceMap } from '../../helpers/Utils/windowSize';
import { getDeviceType as getDeviceTypeSelector } from '../../selectors/CMPageSelector';
import { metaDataElement, metaDataProperty } from '../../utils/cmPreviewMetaData';
import { commonAutomationIds, ctaAutomationIds } from '../CoreMediaPage/CMPage.config';

const ShoppableImage = (props) => {
    const data = get(props, 'data', props);
    const { automationId } = data;
    const teaserTitle = get(data, 'teaserTitle', '');
    const teaserSubtitle = get(data, 'teaserSubtitle', '');
    const ctaData = get(data, 'cta', []);
    const styles = get(data, 'styles', {});
    const windowSize = useWindowSize();
    const deviceType = useSelector((state) => getDeviceTypeSelector(state));
    const { isPreview } = props;
    const { isCMPreview } = props;

    const getHotZonesMidPoint = (type) => {
        let hotZonesCoords = {};
        let Coords = {};
        let midPoint = '';
        hotZonesCoords = type.coords.split(',');
        Coords = hotZonesCoords.map(function (str) {
            return parseInt(str);
        });
        midPoint = `${String((Coords[0] + Coords[2]) / 2)},${String((Coords[1] + Coords[3]) / 2)}`;
        return midPoint;
    };

    const getMapDetails = () => {
        let result = {};
        data?.pictureVariants.forEach((currentVariant) => {
            const {
                variant,
                target: { picture, hotZones },
            } = currentVariant;
            if (variant === windowSize || deviceMap[variant] === keys(pickBy(deviceType))[0]) {
                const hotZonesObj = hotZones.map((type) => ({
                    ...type,
                    coords: getHotZonesMidPoint(type),
                }));
                result = {
                    hotZones: hotZonesObj,
                    imageAltText: picture.alt,
                    imageUrl: picture.fullyQualifiedUrl,
                };
            }
        });
        return result;
    };

    const constructLeaf = (mapArea) => {
        return mapArea?.map((data = {}) => {
            const bannerData = {};
            bannerData.ppid = data?.linkedContent?.productId;
            return { ...data, ...bannerData };
        });
    };

    const openMiniPdpEvent = (ppid) => {
        const customEvent = document.createEvent('CustomEvent');
        customEvent.initCustomEvent('miniPDP.open', true, true, { ppId: ppid });
        document.dispatchEvent(customEvent);
    };

    const TeaserTitle = () => {
        return (
            <div
                className={dt([
                    'md:text-[36px]',
                    'sm:text-[32px]',
                    'text-center',
                    'font-open-sans-bold',
                    'text-black',
                    'break-words',
                    'leading-[1.22]',
                    '-tracking-[2px]',
                ])}
                style={{ color: `#${styles?.componentHeadlineColor}`, inlineSize: '100%' }}
                data-cm-metadata={isCMPreview && metaDataProperty('teaserTitle')}
                data-automation-id={commonAutomationIds?.MAINTITLE}
            >
                {teaserTitle}
            </div>
        );
    };

    const TeaserSubtitle = () => {
        return (
            <div
                className={dt([
                    'text-[20px]',
                    'mb-2',
                    'text-center',
                    'leading-[1.6]',
                    'text-black',
                ])}
                style={{ color: `#${styles?.componentSubHeadlineColor}` }}
                data-cm-metadata={isCMPreview && metaDataProperty('teaserSubtitle')}
                data-automation-id={commonAutomationIds?.MAINSUBTITLE}
            >
                {teaserSubtitle}
            </div>
        );
    };

    const componentCTALinkStyle = dt([
        'h-[56px]',
        'self-stretch',
        'grow',
        'flex',
        'flex-row',
        'justify-center',
        'items-center',
        'px-4',
        'pb-2',
        'underline',
        'w-auto',
    ]);

    const CtaComponent = () => {
        return (
            <div
                className={dt(['mb-6'])}
                data-cm-metadata={isCMPreview && metaDataProperty('targets')}
            >
                {ctaData?.ctaText ? (
                    <a
                        className={`${componentCTALinkStyle} ${dt(['text-[20px]'])}`}
                        style={{ color: `#${styles?.componentSubHeadlineColor}` }}
                        id="componentCTA"
                        aria-label={ctaData?.ctaText}
                        target={ctaData?.urlHolder?.openInNewTab ? '_blank' : ''}
                        href={ctaData?.urlHolder?.value}
                        alt={ctaData?.ctaAltText}
                        title={ctaData?.ctaAltText}
                        data-automation-id={ctaAutomationIds?.BUTTON}
                        preset="text"
                        size="small"
                        type="button"
                        rel="noreferrer"
                        data-cm-metadata={isCMPreview && metaDataElement(data)}
                    >
                        {ctaData?.ctaText}
                    </a>
                ) : (
                    ''
                )}
            </div>
        );
    };

    const { imageAltText, imageUrl, hotZones } = getMapDetails();
    return (
        <div
            className="shoppableImage-container"
            data-cm-metadata={isCMPreview && metaDataElement(data)}
            data-automation-id={automationId}
        >
            <div>
                {!!teaserTitle && <TeaserTitle />}
                {!!teaserSubtitle && <TeaserSubtitle />}
                {!isEmpty(ctaData) && <CtaComponent />}
            </div>
            <ImageMapBanner
                imageUrl={imageUrl}
                imagemapArea={constructLeaf(hotZones)}
                imageAltText={imageAltText}
                analyticsTag={get(data, 'campaignId', data)}
                automationId="at-shoppable-hotspots"
                location="hp-shoppable-image"
                hasPin
                onClick={openMiniPdpEvent}
                CMcomponent={isPreview}
            />
        </div>
    );
};
export default ShoppableImage;
